import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditCategories from "../../components/categories/FormAddEditCategories";
import { useGetCategoryById } from "../../hooks/categories/useGetCategoryById";
import LoadingPage from "../../components/global/LoadingPage";

const EditCategory = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, category } = useGetCategoryById(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/categories");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCategories
                isEdit={true}
                currentData={category}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditCategory;
